var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "login-container" },
    [
      _c(
        "el-form",
        {
          ref: "loginForm",
          staticClass: "login-form",
          attrs: {
            model: _vm.loginForm,
            rules: _vm.loginRules,
            autocomplete: "on",
            "label-position": "left"
          }
        },
        [
          _c("div", { staticClass: "title-container" }, [
            _c("h3", { staticClass: "title" }, [_vm._v("組織連絡管理サイト")])
          ]),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                prop: "company_id",
                rules: {
                  required: true,
                  validator: _vm.validateName,
                  colname: "企業ID"
                }
              }
            },
            [
              _c("i", { staticClass: "el-icon-house svg-container" }),
              _vm._v(" "),
              _c("el-input", {
                attrs: {
                  placeholder: "企業ID",
                  name: "company_id",
                  type: "text",
                  tabindex: "1"
                },
                model: {
                  value: _vm.loginForm.company_id,
                  callback: function($$v) {
                    _vm.$set(_vm.loginForm, "company_id", $$v)
                  },
                  expression: "loginForm.company_id"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                prop: "id",
                rules: {
                  required: true,
                  validator: _vm.validateName,
                  colname: "ユーザーID"
                }
              }
            },
            [
              _c("i", { staticClass: "el-icon-user svg-container" }),
              _vm._v(" "),
              _c("el-input", {
                attrs: {
                  placeholder: "ユーザーID",
                  name: "id",
                  type: "text",
                  tabindex: "2"
                },
                model: {
                  value: _vm.loginForm.id,
                  callback: function($$v) {
                    _vm.$set(_vm.loginForm, "id", $$v)
                  },
                  expression: "loginForm.id"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tooltip",
            {
              attrs: {
                content: "Caps lock is On",
                placement: "right",
                manual: ""
              },
              model: {
                value: _vm.capsTooltip,
                callback: function($$v) {
                  _vm.capsTooltip = $$v
                },
                expression: "capsTooltip"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "password",
                    rules: {
                      required: true,
                      validator: _vm.validatePassword,
                      colname: "パスワード"
                    }
                  }
                },
                [
                  _c("i", { staticClass: "el-icon-key svg-container" }),
                  _vm._v(" "),
                  _c("el-input", {
                    key: _vm.passwordType,
                    ref: "password",
                    attrs: {
                      type: _vm.passwordType,
                      placeholder: "パスワード",
                      name: "password",
                      tabindex: "3",
                      autocomplete: "new-password"
                    },
                    on: {
                      blur: function($event) {
                        _vm.capsTooltip = false
                      }
                    },
                    nativeOn: {
                      keyup: [
                        function($event) {
                          return _vm.checkCapslock($event)
                        },
                        function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.handleLogin($event)
                        }
                      ]
                    },
                    model: {
                      value: _vm.loginForm.password,
                      callback: function($$v) {
                        _vm.$set(_vm.loginForm, "password", $$v)
                      },
                      expression: "loginForm.password"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "show-pwd", on: { click: _vm.showPwd } },
                    [
                      _c("svg-icon", {
                        attrs: {
                          "icon-class":
                            _vm.passwordType === "password" ? "eye" : "eye-open"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "colorButton",
              staticStyle: { width: "100%", "margin-bottom": "30px" },
              attrs: { loading: _vm.loading },
              nativeOn: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.handleLogin($event)
                }
              }
            },
            [_vm._v("ログイン")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "Or connect with", visible: _vm.showDialog },
          on: {
            "update:visible": function($event) {
              _vm.showDialog = $event
            }
          }
        },
        [
          _vm._v(
            "\n    Can not be simulated on local, so please combine you own business simulation! ! !\n    "
          ),
          _c("br"),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("social-sign")
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }